export default "__VITE_ASSET__ceb89621__"